import React from 'react'
import ReactDOM from 'react-dom/client'
import Box from '@mui/material/Box'

const App = () => {
  return (
    <Box
      sx={{
        pt: 0,
        m: 0,
      }}
    >
      <Box
        component="img"
        src="/img/placeholder.jpeg"
        sx={{
          width: '100%',
        }}
      />
    </Box>
  )
}

let render = () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    <>
      <App />
    </>
  )
}

render()